import * as d3 from 'd3';
import theme from '../../theme';

const toPoints = (data, values) =>
    (values || [])
        .map((y, i) => ({ x: new Date(data[i]?.start_date), y }))
        .filter((d) => d.y !== null && d.y !== undefined && !isNaN(d.y));

// Kumo (cloud) fill via two sign-filtered d3.area() passes (D3 has no
// native "fill by which series is on top" primitive) + tenkan/kijun/chikou
// lines. The single most expensive draw call in the engine -- callers must
// only invoke this on data/zoom change, never on crosshair mousemove.
export const drawIchimokuCloud = (svg, data, xScale, yScale, values) => {
    try {
        const { conversion_line, base_line, span_a, span_b, lagging_span } = values || {};
        if (!span_a || !span_b) return;

        const cloudPoints = data.map((d, i) => ({
            x: new Date(d.start_date),
            a: span_a[i],
            b: span_b[i],
        })).filter((d) => d.a != null && d.b != null && !isNaN(d.a) && !isNaN(d.b));

        if (cloudPoints.length > 0) {
            const areaBull = d3
                .area()
                .x((d) => xScale(d.x))
                .y0((d) => yScale(d.b))
                .y1((d) => yScale(d.a))
                .defined((d) => d.a >= d.b)
                .curve(d3.curveMonotoneX);
            const areaBear = d3
                .area()
                .x((d) => xScale(d.x))
                .y0((d) => yScale(d.b))
                .y1((d) => yScale(d.a))
                .defined((d) => d.a < d.b)
                .curve(d3.curveMonotoneX);

            svg.append('path').datum(cloudPoints).attr('fill', theme.indicators.ichimoku.cloudBull).attr('d', areaBull);
            svg.append('path').datum(cloudPoints).attr('fill', theme.indicators.ichimoku.cloudBear).attr('d', areaBear);
        }

        const lineGen = d3.line().x((d) => xScale(d.x)).y((d) => yScale(d.y)).curve(d3.curveMonotoneX);

        const tenkan = toPoints(data, conversion_line);
        if (tenkan.length) {
            svg.append('path').datum(tenkan).attr('fill', 'none').attr('stroke', theme.indicators.ichimoku.tenkan).attr('stroke-width', 1.25).attr('d', lineGen);
        }
        const kijun = toPoints(data, base_line);
        if (kijun.length) {
            svg.append('path').datum(kijun).attr('fill', 'none').attr('stroke', theme.indicators.ichimoku.kijun).attr('stroke-width', 1.25).attr('d', lineGen);
        }
        const chikou = toPoints(data, lagging_span);
        if (chikou.length) {
            svg.append('path')
                .datum(chikou)
                .attr('fill', 'none')
                .attr('stroke', theme.indicators.ichimoku.chikou)
                .attr('stroke-width', 1)
                .attr('stroke-dasharray', '3,3')
                .attr('opacity', 0.7)
                .attr('d', lineGen);
        }
    } catch (error) {
        console.warn('Error drawing Ichimoku Cloud:', error);
    }
};
